import React, { Component } from 'react';
import { ScrollView, View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {
  FilterBar,
  VFButton,
  SectionHeader,
  VFText,
  ErrorScreen,
} from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import AddOnsInlineContent from '../../Components/AddOnsInlineContent';
import AddOnsList from '../../Components/AddOnsList';
import AddOnsLoading from '../AddOnsLoading';
import Timeline from '../Timeline';

import styles from './AddOns.Styles';

class AddOns extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addOns: this.props.data,
      selectedCategories: [],
      isTimeLineView: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.data, this.props.data)) {
      this.setState({
        addOns: this.props.data,
      });
      this.handleFilterAddons(this.state.selectedCategories);
    }
  }

  setSelectedCategories = categoryId => {
    const { selectedCategories } = this.state;
    if (!categoryId) {
      this.setState({ selectedCategories: [] }, () => {
        this.handleFilterAddons();
      });
      return;
    }
    if (!_.includes(selectedCategories, categoryId)) {
      this.setState({ selectedCategories: [...this.state.selectedCategories, categoryId] }, () => {
        this.handleFilterAddons(categoryId);
      });
    } else {
      this.setState(
        {
          selectedCategories: [...selectedCategories.filter(c => c !== categoryId)],
        },
        () => {
          this.handleFilterAddons(categoryId);
        },
      );
    }
  };

  handleFilterAddons = categoryId => {
    const { selectedCategories } = this.state;
    const { data } = this.props;
    let filteredAddons = [];
    if (categoryId && selectedCategories.length) {
      const filteredCategories = data.filter(item => {
        return _.includes(selectedCategories, item.category.id);
      });
      filteredAddons = filteredCategories;
    } else {
      filteredAddons = data;
    }
    this.setState({ addOns: filteredAddons });
  };

  toggleTimeline = () => {
    const { isTimeLineView } = this.state;
    this.setState({ isTimeLineView: !isTimeLineView });
  };

  renderTimeline = () => {
    const {
      data,
      images,
      currentPlan,
      onItemPress,
      currentPlanIconName,
      renewableAddonIconName,
      isTimeLineRefreshed,
    } = this.props;
    return (
      <Timeline
        data={data}
        currentPlan={currentPlan}
        images={images}
        onItemPress={onItemPress}
        currentPlanIconName={currentPlanIconName}
        renewableAddonIconName={renewableAddonIconName}
        isTimeLineRefreshed={isTimeLineRefreshed}
      />
    );
  };

  renderAddonsList = () => {
    const {
      inlineContentData,
      isInlineContentEnabled,
      images,
      onItemPress,
      onInlineContentPress,
      withStatusBadge,
      renderAddOnsCardFooter,
      showInActiveAddons,
      omitLongText,
      withCategories,
    } = this.props;
    return (
      <>
        {_.size(this.state.addOns) ? (
          <>
            <AddOnsList
              data={this.state.addOns}
              images={images}
              onItemPress={onItemPress}
              withStatusBadge={withStatusBadge}
              renderAddOnsCardFooter={renderAddOnsCardFooter}
              showInActiveAddons={showInActiveAddons}
              omitLongText={omitLongText}
              withCategories={withCategories}
            />
            {isInlineContentEnabled && (
              <AddOnsInlineContent
                {...(inlineContentData || {})}
                onButtonPress={onInlineContentPress}
              />
            )}
          </>
        ) : (
          <VFText i18nKey={'addons_not_available'} style={styles.noAddonsText} />
        )}
      </>
    );
  };

  renderBody = () => {
    const { isTimeLineView } = this.state;
    return isTimeLineView ? this.renderTimeline() : this.renderAddonsList();
  };

  render() {
    const { isTimeLineView } = this.state;
    const {
      theme,
      buttonStyle,
      headerSubTitleStyle,
      withTray,
      handleNavigateToAddonsShop,
      addOnsListIcon,
      addOnsTimelineIcon,
      withTimeline,
      data,
      isLoading,
      isError,
      onTryAgainPress,
      errorText,
      errorImages,
      errorIconName,
      tryAgainIconName,
      withCategories,
      categories,
    } = this.props;
    let rightSectionProps = {};
    if (withTimeline) {
      rightSectionProps = {
        rightText: !isTimeLineView ? 'addons_list_switch' : 'addons_timeline_switch',
        rightIcon: !isTimeLineView ? addOnsTimelineIcon : addOnsListIcon,
        onRightSectionPress: this.toggleTimeline,
      };
    }
    const sectionHeaderTitle = !isTimeLineView
      ? 'manage_addon_addons_title'
      : 'addons_timeline_section_title';
    const subtitleProp = {};
    if (isTimeLineView) {
      subtitleProp.subtitle = 'addons_timeline_section_description';
    } else {
      if (_.size(data)) {
        subtitleProp.subtitle = 'manage_addon_active_addon_title';
      }
    }

    return isLoading ? (
      <AddOnsLoading />
    ) : isError ? (
      <View style={styles.errorContainer}>
        <VFText i18nKey={sectionHeaderTitle} style={styles.headerTitle(theme)} />
        <ErrorScreen
          iconStyle={styles.errorIconStyle}
          text={errorText}
          images={errorImages}
          iconName={errorIconName}
          iconButtonName={tryAgainIconName}
          onPress={onTryAgainPress}
        />
      </View>
    ) : (
      <ScrollView
        style={styles.container(withTray, isTimeLineView)}
        testID={FrameworkTestKeys.AddonsListScroll}
      >
        {!isTimeLineView && (
          <VFButton
            title="manage_addon_buy_action_title"
            style={[styles.button, buttonStyle]}
            type="primary"
            onPress={() => {
              handleNavigateToAddonsShop();
            }}
            testKey={FrameworkTestKeys.BuyAddOnsButton}
          />
        )}

        <SectionHeader
          theme={theme}
          title={sectionHeaderTitle}
          style={styles.sectionHeader(isTimeLineView)}
          {...(!withCategories && subtitleProp)}
          titleStyle={headerSubTitleStyle}
          {...rightSectionProps}
        />
        {withCategories && (
          <FilterBar
            setSelectedCategories={this.setSelectedCategories.bind(this)}
            selectedCategories={this.state.selectedCategories}
            filterData={categories}
            style={styles.filterBar}
          />
        )}
        {this.renderBody()}
      </ScrollView>
    );
  }
}

AddOns.defaultProps = {
  theme: LightThemeColors,
  withTimeline: true,
  withStatusBadge: false,
  showInActiveAddons: false,
  withCategories: false,
  categories: [],
};
AddOns.propTypes = {
  withTray: PropTypes.bool,
  data: PropTypes.array,
  inlineContentData: PropTypes.object,
  isInlineContentEnabled: PropTypes.bool,
  images: PropTypes.object,
  buttonStyle: ViewPropTypes.style,
  headerSubTitleStyle: ViewPropTypes.style,
  handleNavigateToAddonsShop: PropTypes.func,
  onItemPress: PropTypes.func,
  onInlineContentPress: PropTypes.func,
  currentPlan: PropTypes.shape({
    name: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    value: PropTypes.number,
    currency: PropTypes.string,
  }),
  currentPlanIconName: PropTypes.string,
  renewableAddonIconName: PropTypes.string,
  addOnsListIcon: PropTypes.object,
  addOnsTimelineIcon: PropTypes.object,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  withTimeline: PropTypes.bool,
  isTimeLineRefreshed: PropTypes.bool,
  isLoading: PropTypes.bool,
  withStatusBadge: PropTypes.bool,
  isError: PropTypes.bool,
  onTryAgainPress: PropTypes.func,
  errorText: PropTypes.string,
  errorImages: PropTypes.array,
  errorIconName: PropTypes.string,
  tryAgainIconName: PropTypes.string,
  renderAddOnsCardFooter: PropTypes.func,
  showInActiveAddons: PropTypes.bool,
  omitLongText: PropTypes.bool,
  withCategories: PropTypes.bool,
  categories: PropTypes.array,
};

export default withTheme(AddOns);
